import { useCallback, useEffect, useState } from "react";
import TextInput from "@joinTrilo/ui/atoms/TextInput";

type PasswordProps = {
    updatePassword: (password: string | undefined) => void;
};

const minPasswordLength = 8;

const INPUT_PASSWORD = "current-password";

export const Password = ({ updatePassword }: PasswordProps) => {
    const [password, setPassword] = useState("");
    const [isPasswordValid, setIsPasswordValid] = useState(false);

    const checkPasswordValid = useCallback(() => {
        let passwordValid = false;
        if (password.length >= minPasswordLength) {
            passwordValid = true;
        }

        return passwordValid;
    }, [password]);

    useEffect(() => {
        setIsPasswordValid(false);
        if (password) {
            setIsPasswordValid(checkPasswordValid());
        }
    }, [password, checkPasswordValid]);

    useEffect(() => {
        if (isPasswordValid) {
            updatePassword(password);
        } else {
            updatePassword(undefined);
        }
    }, [password, updatePassword, isPasswordValid]);

    return (
        <>
            <TextInput
                inputStyle="regular"
                autoComplete="current-password"
                autoCapitalize="off"
                label="Enter password"
                placeholder="Enter password"
                spellCheck={false}
                type="password"
                name={INPUT_PASSWORD}
                id={INPUT_PASSWORD}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: "100%" }}
                invalid={false}
                disabled={false}
            />
        </>
    );
};
